import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import { camelize } from '../helpers';
import dropdown from '../components/dropdown';


class Module extends Component {
  setupDefaults() {
    this.dom = {
      dataContainer: document.querySelectorAll('.longform-content'),
      headings:  [...document.querySelectorAll('.longform-content h2, .longform-content h3, .longform-content h4')],
      navContainer: this.el.querySelector('.table-of-contents-summary__list'),
      tabsContainer: this.el.querySelector('.table-of-contents-summary__sm-device'),
      summaryDropdown: this.el.querySelector('.table-of-contents-summary__select')
    },
    this.isDesktop = window.matchMedia('(min-width: 1280px)');
    this.tableOfContent();

    if (this.dom.headings.length !== 0) {
      this.el.style.display = 'block';
      if (this.dom.summaryDropdown) {
        this.dom.summaryDropdown = new dropdown(this.dom.summaryDropdown)
        this.dom.summaryDropdown.on('option', this.handleOptionChange.bind(this))
      }
    } else {
      this.el.style.display = 'none';
    }
  }

  addListeners() {
    if (this.isDesktop) {
      window.addEventListener('scroll', this.navHighlighter.bind(this));
    }
  }

  navHighlighter(e) {
    const sections = document.querySelectorAll('h2[id], h3[id], h4[id]');
    const scrollY = window.pageYOffset;
    sections.forEach((current, index) => {
      const sectionTop = current.getBoundingClientRect().top + window.scrollY - 100;
      const sectionId = current.getAttribute('id');
      if (index !== sections.length - 1) {
        const nextSectionTop = sections[index + 1].getBoundingClientRect().top + window.scrollY - 100;
        if (
          scrollY > sectionTop &&
        scrollY <= sectionTop + nextSectionTop
        ){
          if (index !== 0) {
            const prevSectionId = sections[index - 1].getAttribute('id');
            document.querySelector(`.table-of-contents-summary__inner a[href*= '${prevSectionId}']`).classList.remove('active');
          }
          const anchor = document.querySelector(`.table-of-contents-summary__inner a[href*= '${sectionId}']`)
          anchor.classList.add('active');
          gsap.to(this.dom.navContainer, { duration: 0, scrollTo: anchor.offsetTop - 200 });
        } else {
          document.querySelector(`.table-of-contents-summary__inner a[href*= '${sectionId}']`).classList.remove('active');
        }
      } else {
        if (scrollY > sectionTop) {
          if (index !== 0) {
            const prevSectionId = sections[index - 1].getAttribute('id');
            document.querySelector(`.table-of-contents-summary__inner a[href*= '${prevSectionId}']`).classList.remove('active');
          }
          const anchor = document.querySelector(`.table-of-contents-summary__inner a[href*= '${sectionId}']`)
          anchor.classList.add('active');
          gsap.to(this.dom.navContainer, { duration: 0, scrollTo: anchor.offsetTop });
        } else {
          document.querySelector(`.table-of-contents-summary__inner a[href*= '${sectionId}']`).classList.remove('active');
        }
      }
    });
  }

  tableOfContent() {
    if (this.dom.headings) {
      const summary = this.dom.headings
        .map(head => {
          head.id = camelize(head.innerText);
          if (head.localName === 'h2')
            return `<li><a href="#${head.id}">${head.innerText}</a></li>`;
          else if (head.localName === 'h3')
            return `<ul><li><a href="#${head.id}">${head.innerText}</a></li></ul>`;
          return `<ul><ul><li><a href="#${head.id}">${head.innerText}</a></li></ul></ul>`;
        })
        .join('');
      this.dom.navContainer.innerHTML = summary;

      this.dom.jumpLinks = [...this.dom.navContainer.querySelectorAll('a')];
      this.dom.jumpLinks.forEach(link =>
        link.addEventListener('click', this.handleJumpLinkClick.bind(this))
      );
      this.handleCheckInitialAnchor();

      const options = this.dom.headings
        .map(head => {
          head.id = camelize(head.innerText);
          return `<option value="${head.id}">${head.innerText}</option><a href="#${head.id}">${head.innerText}</a>`;
        })
        .join('');
      this.dom.summaryDropdown.innerHTML = options;
    }
  }

  jumpToContent(targetId, push) {
    let height;
    const target = document.getElementById(targetId.replace('#', ''));

    const isDesktop = window.matchMedia('(min-width: 1280px)');
    const isTablet = window.matchMedia('(min-width: 768px)');
    const isMobile = !isTablet.matches && !isDesktop.matches;

    if (this.isDesktop.matches) height = 96;
    else if (isTablet.matches) height = 276;
    else if (isMobile) height = 240;

    if (target) {
      gsap.to(window, { duration: 0, scrollTo: target.getBoundingClientRect().top + window.scrollY - height });

      if (push) {
        history.pushState(null, null, targetId);
      }
    }
  }

  handleJumpLinkClick(e) {
    e.preventDefault();

    const targetId = e.target.getAttribute('href');
    this.jumpToContent(targetId, true);
  }

  handleCheckInitialAnchor() {
    const { hash } = window.location;

    if (hash) {
      this.jumpToContent(hash);
    }
  }

  handleOptionChange(e) {
    const id = e.target.value;
    this.jumpToContent(id);
  }
}




export default Module;
